import React from "react";

export default function PlatformNewsArticleSection({
                                                       icon,
                                                       title,
                                                       children,
                                                   }) {
    return (
        <section className="platform-news-article__section">
            <h2 className="platform-news-article__section-title">
                <span aria-hidden="true">{icon}</span>
                {title}
            </h2>

            {children}
        </section>
    );
}
